import React from 'react';
import {
  LayoutDashboard,
  Trello,
  PenTool,
  FileText,
  Calendar,
  Sparkles,
  Users as UsersIcon,
  Boxes,
  Settings as SettingsIcon,
  LogOut,
  Bell,
  Search as SearchIcon,
  X,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  ChevronLeft,
  Check,
  Plus,
  Menu as MenuIcon,
  Edit2,
  Trash2,
  Sliders,
  Box,
  Layers,
  Target,
  TrendingUp,
  TrendingDown,
  Package,
  Tag,
  BookOpen,
  Briefcase,
  Crosshair,
  AlertCircle,
  Info,
  HelpCircle,
  Grid,
  Home,
  MessageCircle,
  MessageSquare,
  Heart,
  User as UserIcon,
} from 'lucide-react';

export type IconName =
  | 'dashboard'
  | 'taskboard'
  | 'whiteboard'
  | 'docs'
  | 'calendar'
  | 'featureStudio'
  | 'users'
  | 'customers'
  | 'product'
  | 'settings'
  | 'logout'
  | 'bell'
  | 'notification'
  | 'search'
  | 'close'
  | 'chevronDown'
  | 'chevronUp'
  | 'chevronRight'
  | 'chevronLeft'
  | 'check'
  | 'plus'
  | 'menu'
  | 'edit'
  | 'trash'
  | 'sliders'
  | 'box'
  | 'layers'
  | 'target'
  | 'trendingUp'
  | 'trendingDown'
  | 'package'
  | 'tag'
  | 'bookOpen'
  | 'briefcase'
  | 'crosshair'
  | 'alertCircle'
  | 'info'
  | 'help'
  | 'grid'
  | 'home'
  | 'messageCircle'
  | 'messageSquare'
  | 'heart'
  | 'user';

const map: Record<IconName, React.ComponentType<any>> = {
  dashboard: LayoutDashboard,
  taskboard: Trello,
  whiteboard: PenTool,
  docs: FileText,
  calendar: Calendar,
  featureStudio: Sparkles,
  users: UsersIcon,
  customers: UsersIcon,
  product: Boxes,
  settings: SettingsIcon,
  logout: LogOut,
  bell: Bell,
  notification: Bell,
  search: SearchIcon,
  close: X,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  check: Check,
  plus: Plus,
  menu: MenuIcon,
  edit: Edit2,
  trash: Trash2,
  sliders: Sliders,
  box: Box,
  layers: Layers,
  target: Target,
  trendingUp: TrendingUp,
  trendingDown: TrendingDown,
  package: Package,
  tag: Tag,
  bookOpen: BookOpen,
  briefcase: Briefcase,
  crosshair: Crosshair,
  alertCircle: AlertCircle,
  info: Info,
  help: HelpCircle,
  grid: Grid,
  home: Home,
  messageCircle: MessageCircle,
  messageSquare: MessageSquare,
  heart: Heart,
  user: UserIcon,
};

export interface IconProps {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  className?: string;
  color?: string;
}

const Icon: React.FC<IconProps> = ({ name, size = 20, strokeWidth = 1.8, className, color }) => {
  const Cmp = map[name];
  if (!Cmp) return null;
  return <Cmp size={size} strokeWidth={strokeWidth} className={className} color={color} />;
};

export default Icon;
